import { axiosMock } from '../client';
import { API_URL } from '../apiDictionary';
import { createPaginatedReaderTaskList } from 'src/mocks/readerTasks';
import { USE_API_MOCKS } from 'src/env';

type PaginatedArgs = {
  page?: number;
  size?: number;
};

export const fetchReaderTasksMock = (args?: PaginatedArgs) => {
  if (!USE_API_MOCKS) {
    return;
  }
  const data = createPaginatedReaderTaskList({
    page: 0,
    size: 100,
  });

  axiosMock.onGet(API_URL.readerTasks).reply(200, data);
  axiosMock.onGet(API_URL.readerTasks, {
    params: {
      page: args?.page,
      size: args?.size,
    },
  });
};
